import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromProducts from '../reducers/products.reducer';

export const selectProductsState = createFeatureSelector<fromProducts.State>(
  fromProducts.productsFeatureKey
);

export const selectProductsFilterTypeState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.filterType
);

export const selectProductsIsLoadingState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.isLoading
);

export const selectProductsIsMaster = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.isMasterChecked
);


export const selectProductListState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.products
);

export const selectProductsFilterIDState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.filterID
);

export const selectProductsQueryState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.query
);

export const selectProductsSelectedState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.selected
);

export const selectProductsBarcodeState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.barcodes
);

export const selectProductState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.product
);

export const selectProductsDuplicateBarcodeState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.duplicateBarcode
);

export const selectProductsSortState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.sortType
);

export const selectProductsDirectionState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.direction
);

export const selectProductPageState = createSelector(
  selectProductsState,
  (state: fromProducts.State) => {
    state.direction
  }
);

export const selectDisplayedColumns = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.displayedColumns
);

export const selectAllColumns = createSelector(
  selectProductsState,
  (state: fromProducts.State) => state.allColumns
);
